module.exports = __webpack_public_path__ + "img/favicon.de895bf5.svg";